<template>
    <div v-if="hasActionPlansData" class="action-plans-container">
        <!-- Icono rojo - Abiertos -->
        <div v-if="open > 0" class="action-plan-item action-plan-open">
            <i class="i-andy-circle-exclamation action-plan-icon icon-red"></i>
            <span class="action-plan-count action-plan-count-open">{{ open }}</span>
        </div>

        <!-- Icono amarillo - En progreso -->
        <div v-if="inProgress > 0" class="action-plan-item action-plan-in-progress">
            <i class="i-andy-hourglass-warning action-plan-icon icon-yellow"></i>
            <span class="action-plan-count action-plan-count-in-progress">{{ inProgress }}</span>
        </div>

        <!-- Icono verde - Completados -->
        <div v-if="completed > 0" class="action-plan-item action-plan-completed">
            <i class="i-andy-menu-checklist action-plan-icon icon-green"></i>
            <span class="action-plan-count action-plan-count-completed">{{ completed }}</span>
        </div>

        <!-- Icono gris - Otros -->
        <div v-if="others > 0" class="action-plan-item action-plan-others">
            <i class="i-andy-menu-chocolate action-plan-icon icon-gray"></i>
            <span class="action-plan-count action-plan-count-others">{{ others }}</span>
        </div>
    </div>
    <span v-else>-</span>
</template>

<script>
export default {
    name: 'StatusTag',
    props: {
        percentage: {
            type: Number
        },
        open: {
            type: Number,
            default: 0
        },
        inProgress: {
            type: Number,
            default: 0
        },
        completed: {
            type: Number,
            default: 0
        },
        others: {
            type: Number,
            default: 0
        }
    },
    computed: {
        status() {
            if (!this.percentage) return 'none'
            if (this.percentage === 0) return 'none'
            if (this.percentage === 100) return 'completed'
            if (this.percentage > 0 && this.percentage < 100) return 'progress'
            return 'to_start'
        },
        total() {
            return (this.open || 0) + (this.inProgress || 0) + (this.completed || 0) + (this.others || 0)
        },
        hasActionPlansData() {
            return this.total > 0
        }
    },
    mounted() {}
}
</script>

<style lang="scss" scoped>
.action-plans-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    white-space: normal;
    width: 100%;
}

.action-plan-item {
    display: flex;
    padding: 4px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 4px;
    flex-shrink: 0;
    margin: 0;
    box-sizing: border-box;

    &:not(:last-child) {
        margin-right: 8px;
    }

    &.action-plan-open {
        background-color: $color-error-100;
    }

    &.action-plan-in-progress {
        background-color: $color-warning-100;
    }

    &.action-plan-completed {
        background-color: $color-success-100;
    }

    &.action-plan-others {
        background-color: $color-neutral-300;
    }
}

.action-plan-icon {
    font-size: 16px !important;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;

    &.icon-red {
        color: $color-error-500 !important;
    }

    &.icon-yellow {
        color: $color-warning-800 !important;
    }

    &.icon-green {
        color: $color-success-800 !important;
    }

    &.icon-gray {
        color: $color-neutral-600 !important;
    }
}

.action-plan-count {
    font-family: "Avenir Next LT Pro", $text-bold;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 1;
    min-width: auto;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    padding-top: 2px;

    &.action-plan-count-open {
        color: $color-error-500;
    }

    &.action-plan-count-in-progress {
        color: $color-warning-800;
    }

    &.action-plan-count-completed {
        color: $color-success-800;
    }

    &.action-plan-count-others {
        color: $color-neutral-600;
    }
}
</style>
